// ========== Utility Functions ==========
const fetchCart = async () => {
  const response = await fetch('/cart.js');
  if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
  return response.json();
};

const showToast = (message) => {
  const toastContainer = document.querySelector('sticky-header #messageBoxvariant');
  if (!toastContainer) return;
  const timer = Number(`${document.querySelector('.main-section-container-offer-cart')?.getAttribute('timer') || 3}000`);
  toastContainer.querySelector('#messageBoxvariant_inner').textContent = message;
  toastContainer.classList.add('show', 'custom-show');
  setTimeout(() => toastContainer.classList.remove('show', 'custom-show'), timer);
};

const updateCheckoutButton = (data) => {
  const couponPrice = (data.total_discount / 100).toFixed(2);
  const totalPrice = (data.total_price / 100).toFixed(2);

    document.querySelector('.discount-coupon-price')?.setAttribute('coupon-price-value', couponPrice);
    if(document.querySelector('.discount-coupon-price')){
      document.querySelector('.discount-coupon-price').textContent = `-₹${couponPrice}`;
    }
    if(document.querySelector('.button-container button')){
        document.querySelector('.button-container button').textContent = `Continue to Pay ${totalPrice}`;
    }
};

const resetCouponUI = () => {
  document.querySelectorAll('.coupon-code-container').forEach(container => {
    container.querySelector('.inner-coupon-code')?.style.setProperty('display', 'flex');
    container.querySelector('.container-applied-coupon')?.style.setProperty('display', 'none');
  });
  document.querySelectorAll('.error-message-coupon').forEach(msg => {
    msg.style.setProperty('display', 'none');
  });
};

const updateCouponUI = (couponCode, applicable) => {
  document.querySelectorAll('.inner-coupon-code').forEach(item => {
    if (item.getAttribute('coupon-code') === couponCode && applicable) {
      item.style.display = 'none';
      item.classList.add('active-coupon');
      item.nextElementSibling?.style.setProperty('display', 'flex');
    }
  });
};

const showConfetti = () => {
  const confettiEl = document.querySelector('.confetti-animation-container');
  if (confettiEl) {
    confettiEl.style.display = 'block';
    setTimeout(() => (confettiEl.style.display = 'none'), 3000);
  }
};

const savingPriceSection = () => {
  const discountPrice = parseFloat(document.querySelector('.discount-compare-price')?.getAttribute('coupon-price-value')?.replace(/,/g, '') || '0') || 0;
  const couponPrice = parseFloat(document.querySelector('.discount-coupon-price')?.getAttribute('coupon-price-value')?.replace(/,/g, '') || '0') || 0;
  const totalPrice = discountPrice + couponPrice;
  const formatted = totalPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const totalSavingPrice = document.querySelector('.you-save-para .total-savings');
  if (totalSavingPrice) {
    totalSavingPrice.textContent = `₹${formatted}`;
    totalSavingPrice.setAttribute('data-price', `₹ ${formatted}`);
  }
};

window.scrollHorizontal = function () {
  document.querySelectorAll('.main-section-offer-cart').forEach(slider => {
    let isDown = false, startX, scrollLeft;
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    ['mouseleave', 'mouseup'].forEach(ev =>
      slider.addEventListener(ev, () => {
        isDown = false;
        slider.classList.remove('active');
      })
    );
    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      slider.scrollLeft = scrollLeft - (x - startX) * 2;
    });
  });
};

// ========== Main Coupon UI Initialization ==========
window.initializeCouponUI = async function () {
  try {
    const cart = await fetchCart();
    const [discount] = cart.discount_codes || [];

    resetCouponUI();
    updateCouponUI(discount?.code, discount?.applicable);
    updateCheckoutButton(cart);
    savingPriceSection();
    scrollHorizontal();
    loginStatusCheck();
  } catch (error) {
    console.error('Error initializing coupon UI:', error);
  }
};

// ========== Discount Handlers ==========
window.addCouponCode = async function (event) {
  if (!event) return;

  const couponCode = event.getAttribute('coupon-code');
  const orderCount = +event.getAttribute('order-count') || 0;
  const dataPrice = event.getAttribute('data-price');
  const cartPrice = event.getAttribute('cart-price');
  if(dataPrice){
    if(Number(cartPrice) < Number(dataPrice)) return showToast(`Shop for ₹1299 to get this offer`); 
  }

  if (couponCode === 'FIRST10' && orderCount > 0) {
    return showToast(`Coupon “FIRST10” has already been used`);
  }

  try {
    const formData = new FormData();
    formData.append("discount", couponCode);

    const res = await fetch(`${window.Shopify.routes.root}cart/update.js`, { method: 'POST', body: formData });
    const data = await res.json();

    if(data.discount_codes[0]?.applicable===false){
        return showToast(`Invalid coupon code`);
    }
    updateCheckoutButton(data);
    await window.initializeCouponUI();

    if (data.total_discount !== 0) showConfetti();
  } catch (err) {
    console.error('Error applying discount:', err);
  }
};

window.removeDiscountCode = async function (event) {
  try {
    const formData = new FormData();
    formData.append("discount", "");

    const res = await fetch(`${window.Shopify.routes.root}cart/update.js`, { method: 'POST', body: formData });
    const data = await res.json();

    resetCouponUI();
    updateCheckoutButton(data);
    savingPriceSection();

    event?.closest('.container-applied-coupon')?.style.setProperty('display', 'none');
    event?.closest('.coupon-code-container')?.querySelector('.inner-coupon-code')?.style.setProperty('display', 'flex');
  } catch (err) {
    console.error('Error removing discount:', err);
  }
};

// ========== Login Redirect Handler ==========
window.handleLoginAccount = function () {
  sessionStorage.setItem('cart_drawer_login', 'true');
  window.location.href = '/account/login';
};

// ========== Login Check On Load ==========
window.loginStatusCheck = async function(){
    let headerContent = document.querySelector('sticky-header header[customer-status]')
    if(headerContent && headerContent.getAttribute('customer-status') == ''){
        const cart = await fetchCart();
        const [discount] = cart.discount_codes || [];
        if(discount?.code == 'FIRST10'){
            removeDiscountCode();
        }
    }
}
// ========== Auto-Trigger On Load ==========
document.addEventListener('DOMContentLoaded', () => {
  window.initializeCouponUI();
  if (window.location.pathname.endsWith('/account') && sessionStorage.getItem('cart_drawer_login') === 'true') {
    document.querySelector('cart-drawer details summary')?.click();
    sessionStorage.removeItem('cart_drawer_login');
  }
});
